import React from 'react';
import { Banner } from '@common/components';

export const messageByType = {
  offer:
    "By adjusting this rate, you're unlinking it from the rate card. This Offer will not follow future rate card updates.",
  extensionOffer:
    "By adjusting this rate, you're unlinking it from the rate card. This Extension Offer will not follow future rate card updates.",
  extensionOfferCreated:
    "This extension offer's rate is different from the rate card's rate.",
};

export function BillingCardDeviationAlert({
  type = 'offer',
}: {
  type: 'offer' | 'extensionOffer' | 'extensionOfferCreated';
}) {
  return (
    <Banner type="info" showIcon>
      {messageByType[type]}
    </Banner>
  );
}
